class EventRegistration {

  constructor(element, eventType, handler) {

    this.element = element;
    this.eventType = eventType;
    this.handler = handler;

    this.element.addEventListener(eventType, handler);

  }

  cancel() {

    this.element.removeEventListener(this.eventType, this.handler);

  }

}

export default EventRegistration;